module.exports = __webpack_public_path__ + "static/img/fj.ca0a3f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/fj.png
// module id = dPqa
// module chunks = 18